import { IFile, IFileData } from '@dash/file';
import { t } from 'src/i18n';
import { filesConfig } from 'src/settings';

export type IAddNotification = (notification: { type: string; message: string; headline: string }) => void;

type IChangeProperty = (attr: string, file: IFile | null) => void;

export const DOCUMENT_MAX_SIZE = {
  value: filesConfig.documentMaxSize * 1024 * 1024,
  label: 10,
};

const fileValidation = (file: IFile, fileSize = DOCUMENT_MAX_SIZE.value) => file?.size <= fileSize;

export const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }

  return window.btoa(binary);
};

export const beforeImportUpload = (
  file: IFile,
  attr: string,
  addNotification: IAddNotification,
  handlePropertyChange: IChangeProperty,
  fileSizeLabel = DOCUMENT_MAX_SIZE.label,
) => {
  if (!fileValidation(file)) {
    addNotification({
      type: 'error',
      message: t('dash.validation.file_must_be_smaller', { fileSize: `${fileSizeLabel}MB` }),
      headline: t('dash.common.notification.error_headline'),
    });

    return false;
  }

  (file as File).arrayBuffer().then(buffer => {
    file.base64Content = `data:${file.type};base64,${arrayBufferToBase64(buffer)}`;
    handlePropertyChange(attr, file);
  });

  return false;
};

export const onAttachedFileChange = (attr: string, fileData: IFileData, handlePropertyChange: IChangeProperty) => {
  const { file, fileList } = fileData;

  if (!fileValidation(file)) {
    return;
  }

  handlePropertyChange(attr, file.status === 'removed' ? null : fileList[0] || null);

  if (fileList[1]) {
    fileList.shift();
  }
};
